import React from 'react';
import { Grid3X3, List } from 'lucide-react';
import './ViewToggle.css';

export type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  return (
    <div className="view-toggle">
      <span className="view-toggle-label">View:</span>
      <div className="view-toggle-buttons">
        <button
          className={`view-toggle-button ${currentView === 'grid' ? 'active' : ''}`}
          onClick={() => onViewChange('grid')}
          aria-label="Grid view"
          title="Grid view"
        >
          <Grid3X3 size={18} />
        </button>
        <button
          className={`view-toggle-button ${currentView === 'list' ? 'active' : ''}`}
          onClick={() => onViewChange('list')}
          aria-label="List view"
          title="List view"
        >
          <List size={18} />
        </button>
      </div>
    </div>
  );
};

export default ViewToggle; 